import type { SVGProps } from 'react';
const SvgInProgress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.75 8a6.75 6.75 0 0 1-13.5 0c0-2.657 1.546-5.083 3.938-6.181a.75.75 0 1 1 .625 1.363C3.952 4.036 2.75 5.927 2.75 8a5.25 5.25 0 0 0 10.5 0c0-2.073-1.203-3.964-3.063-4.818a.75.75 0 1 1 .626-1.363C13.204 2.917 14.75 5.343 14.75 8Z"
    />
  </svg>
);
export default SvgInProgress;
